import { useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import Notify from "../Usenotifications"
import {
  collection,
  addDoc,
  Timestamp,
  doc,
  updateDoc,
} from "firebase/firestore"
import { db } from "../../../Firebase/config"
export const RatingHook = (orderID, closeModal) => {
  const user = JSON.parse(localStorage.getItem("user"))
  const userPhone = user.phone
  const userName = user.name
  const navigate = useNavigate()
  const [ratingService, setRatingservice] = useState("")
  const [ratingFood, setRatingFood] = useState("")
  const [text, setText] = useState("")
  const location = useLocation()

  const handleRating = (rate: number) => {
    setRatingservice(rate)
  }
  const handleRatingFood = (rate: number) => {
    setRatingFood(rate)
  }

  const handleText = (e) => {
    setText(e.target.value)
  }

  const onSubmitrating = async (e) => {
    e.preventDefault()
    if (ratingService === "" || ratingFood === "") {
      Notify("Please enter a valid rating", "error")
    } else {
      try {
        await addDoc(collection(db, "Reviews"), {
          ratingService: ratingService,
          ratingFood: ratingFood,
          text: text,
          userphone: userPhone,
          userName: userName,
          orderID,
          userID: user.userID,
          createdAt: Timestamp.now().toDate(),
        })

        Notify("Thanks for your review", "success")
        if (closeModal) closeModal()
      } catch (error) {
        Notify("Error occured", "error")
      }
    }
  }

  return [text, handleRating, handleText, handleRatingFood, onSubmitrating]
}
